import apiService from '../apiService';
import svcConfig from './chnlConfig';
import { isDspV3Enabled, resetDspSession } from '../../common/auth/dsp';

const chnlService = {
	perLogon: () => {
		return apiService('preLogon', svcConfig);
	},
	gatewayLogon: (request) => {
		return apiService('gatewayLogon', svcConfig, request);
	},
	retrieveEnvParam: () => {
		return apiService('retrieveEnvParam', svcConfig);
	},
	gatewayLogoff: () => {
		if (isDspV3Enabled()) {
			resetDspSession();
		}
		return apiService('gatewayLogoff', svcConfig);
	},
	keepAlive: () => {
		return apiService('keepAlive', svcConfig);
	},

	// generateToken
	generateToken: {
		method: 'POST',
		url: '/authcontroller/generateToken'
	}
};

export default chnlService;
